<div class="container container_type_center">
  <div class="page-505">
    <div class="page-505__img"></div>
    <div class="page-505__title h2">{{ '500-page.title' | translate }}</div>
    <div class="page-505__subtitle">{{ '500-page.text' | translate }}</div>
    <div class="page-505__button">
      <span (click)="back()" class="button">{{ '500-page.reload' | translate }}</span>
    </div>
  </div>
</div>
